<!-- TODO NEED OPTIMIZATION -->
<template>
  <div class="container-fluid">
    <div class="row">
      <b-modal size="lg" hide-footer ref="bookingModal">
        <template v-slot:modal-header="{ cancel }">
            <h5 class="modal-title">{{ !!editedItem.id ? 'Edit booking' : 'Create booking' }}</h5>
            <button
              type="button"
              aria-label="Close"
              class="close"
              @click.prevent="cancel"
            >
            <span class="material-icons">
              close
            </span>
            </button>
        </template>
        <BookingForm
                v-if="dialog"
                :projects="projects"
                :users="users"
                :unitManagers="unitManagers"
                :dataProps="editedItem"
                :edit="!!editedItem.id"
                :modal="true"
                :isLoading="loading"
                :show-preloader="true"
                @submit="submit"
        />
      </b-modal>
      <div class="col-12">
        <div class="page-table-header">
          <div class="title-container">
            <h3 class="title">
              Booking table
              <div
                class="spinner-border spinner-theme_default"
                role="status"
                v-if="loading"
              >
                <span class="sr-only">
                  Loading...
                </span>
              </div>
            </h3>
            <div class="title-container__controls">
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
              <b-button
                v-if="$can('create-booking_management')"
                variant="success"
                class="button"
                @click="bookingModalOpen()"
                :disabled="loading"
              >
                Create
              </b-button>
            </div>
          </div>

          <Filters
            v-if="$can('read_all-booking_management')"
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="filters"
            :isLoading="loading"
            @submit="getBookingByFilter"
          />

          <TableForPage
            ref="table"
            style="margin-bottom: 0;"
            v-if="table.data.length"
            :isLoading="loading"
            :tableData="table.data"
            :fields="table.fields"
            :slots="table.slots"
            :isEdit="$can('update_all-booking_management')"
            :isRemove="$can('delete-booking_management')"
            @edit="bookingModalOpen"
            @remove="deleteBooking"
            @update="updateTable"
          >
            <template v-slot:user_id="slotProps">
              <TableUserItem :user='__getUser(slotProps.item.user_id)' :number="getNumber(slotProps.index)"/>
            </template>
            <template v-slot:project_id="slotProps">
              <span>{{__getProjectName(slotProps.item.project_id)}}</span>
            </template>
            <template v-slot:hours_per_day="slotProps">
              <span>{{slotProps.item.hours_per_day || '-'}}</span>
            </template>
            <template v-slot:booking_hours="slotProps">
              <span>{{slotProps.item.booking_hours || '-'}}</span>
            </template>
          </TableForPage>
          <error-modal ref="errorModal" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BookingForm from '../components/forms/BookingForm'
import BookingMixin from '../mixins/booking'
import { mapGetters } from 'vuex'
import ErrorModal from '../components/modals/ErrorModal.vue'
import Filters from '@components/Filter/Filter'
import TableForPage from '@tables/TableForPage'
import TableUserItem from '@components/tables/TableUserItem'

export default {
  name: 'BookingManagment',
  data () {
    return {
      loading: true,
      isShowFilter: true,
      currentPage: 1,
      perPage: 15,
      filters: {
        'projects': {
          type: 'multiselect',
          name: 'projectIds',
          label: 'Select projects',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'users': {
          type: 'multiselect',
          name: 'users',
          label: 'Select users',
          valueField: 'jira_user_name',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'unitManagers': {
          type: 'multiselect',
          name: 'unitManagerIds',
          label: 'Select unit managers',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        }
      },
      selectedFilters: {},
      firstLoad: false,
      dialog: false,
      defaultFormData: {},
      editedItem: {
        start_date: ''
      },
      table: {
        fields: [
          {
            key: 'user_id',
            label: 'User',
            class: 'column-long-name'
          },
          {
            key: 'project_id',
            label: 'Project'
          },

          {
            key: 'start_date',
            label: 'Start date'
          },
          {
            key: 'end_date',
            label: 'End date'
          },
          {
            key: 'hours_per_day',
            label: 'Hours per day'
          },
          {
            key: 'booking_hours',
            label: 'Booking hours'
          },
          {
            key: 'comment',
            label: 'Comment'
          },
          {
            key: 'updated_at',
            label: 'Last update'
          },
          {
            key: 'actions',
            label: 'Actions',
            class: 'column_action'
          }
        ],
        data: [],
        slots: {
          project_id: {
            name: 'project_id'
          },
          user_id: {
            name: 'user_id'
          },
          hours_per_day: {
            name: 'hours_per_day'
          },
          booking_hours: {
            name: 'booking_hours'
          }
        }
      },
      users: [],
      projects: []
    }
  },
  components: {
    ErrorModal,
    BookingForm,
    Filters,
    TableForPage,
    TableUserItem
  },
  mixins: [BookingMixin],
  created () {
    (async () => {
      if (this.$can('read_own-booking_management') && !this.$can('read_all-booking_management')) {
        this.filter.users.push(this._UserInfo)
        this.users.push(this._UserInfo)
      }
      await this.axios
        .get('/api/projects', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.filters.projects.options = response.data
            this.projects = response.data
          }
        })
        .catch(err => {
          console.log(err)
        })
      await this.axios
        .post(
          '/api/users-with-trashed',
          {},
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.filters.users.options = response.data
            this.users = response.data
          }
        })
        .catch(err => {
          console.log(err)
        })
      await this.axios
        .post(
          '/api/get-unit-managers',
          {
            unit_managers: []
          },
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.filters.unitManagers.options = response.data
            if (Object.keys(this.$route.query).length !== 0) {
              for (let item in this.$route.query) {
                if (item.indexOf('users') !== -1) {
                  this.users.forEach((element, index) => {
                    if (element.id === +this.$route.query[item]) {
                      this.filters.users.value.push(element)
                      this.users.push(element)
                    }
                  })
                } else if (item.indexOf('unitManagers') !== -1) {
                  this.unitManagers.forEach((element, index) => {
                    if (element.id === +this.$route.query[item]) {
                      this.filters.unitManagers.value.push(element)
                    }
                  })
                } else if (item.indexOf('projects') !== -1) {
                  this.projects.forEach((element, index) => {
                    if (element.id === +this.$route.query[item]) {
                      this.filters.projects.value.push(element)
                      this.projects.push(element)
                    }
                  })
                }
              }
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      await this.getBooking()
    })()
  },
  computed: {
    ...mapGetters({
      dateFormat: 'dateFormat',
      getCurrentUserRole: 'getCurrentUserRole',
      getCurrentUserName: 'getCurrentUserName'
    })
  },
  methods: {
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    prepareDataForGetReports (fields) {
      let data = {}

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Array.isArray(value)) {
          value = value.map(item => item[fields[key]['valueField']])
        }

        data[name] = value
      }

      return data
    },
    resetPagination () {
      this.$refs['table'] && this.$refs['table'].resetPagination()
    },
    async getBookingByFilter (fields) {
      this.selectedFilters = fields
      this._setRouteByFields(fields)
      await this.getBooking()
    },
    getBooking () {
      const data = this.prepareDataForGetReports(this.selectedFilters)

      this.loading = true
      return this.axios
        .post('/api/bookings', data, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(response => {
          this.table.data = response.data
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.loading = false
          this.firstLoad = true
        })
    },
    create (data) {
      this.loading = true
      this.axios
        .post('/api/booking/create', data, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(({ data }) => {
          let title = data.success ? 'Booking created successfully' : 'Booking was not created'
          this.$refs.errorModal.open({
            title: title,
            data: data.messages || []
          }).then(() => {
            this.dialog = false
            this.getBooking()
            this.editedItem = {}
            this.$refs['bookingModal'].hide()
          })
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    bookingModalOpen (data = {}) {
      this.editedItem = Object.assign({}, data)
      this.dialog = true
      this.$refs['bookingModal'].show()
    },
    edit (data) {
      this.loading = true
      this.axios
        .post('/api/booking/update/' + this.editedItem.id, data, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(({ data }) => {
          let title = data.success ? 'Booking edited successfully' : 'Booking was not edited'
          this.$refs.errorModal.open({
            title: title,
            data: data.messages || []
          }).then(() => {
            if (data.success) {
              this.dialog = false
              this.getBooking()
              this.editedItem = {}
              this.$refs['bookingModal'].hide()
            }
          })
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    submit (data) {
      if (this.editedItem.id) {
        this.edit(data)
      } else {
        this.create(data)
      }
    },
    async deleteBooking (item) {
      this.loading = true
      const { id } = item

      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete?'
      )

      if (!confirm) {
        this.loading = false
        return
      }

      this.axios
        .post(
          '/api/booking/delete/' + id,
          {},
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .finally(() => {
          this.getBooking()
        })
    },
    updateTable (data) {
      this.currentPage = data.currentPage
      this.perPage = data.perPage
    },
    getNumber (index) {
      if (this.currentPage > 1) {
        const curPage = this.currentPage - 1
        return (this.perPage * curPage) + index
      } else {
        return index
      }
    }
  },
  updated () {}
}
</script>

<style scoped lang="scss">
.table-wrapper {
  padding-top: 20px;
}
.table-wrapper h3 {
  margin-bottom: 30px;
}
.booking-table {
  background-color: #fff;
}
.booking-table-wrapper {
  max-height: 600px;
  overflow-y: auto;
}
.spinner-border {
  border-width: 0.25rem !important;
}
.filter-buttons {
  padding-top: 34px;
}
</style>
